"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stateful = exports.stateful = void 0;
const widget_1 = require("../basics/widget");
const react_1 = require("react");
const react_2 = __importDefault(require("react"));
const stateful = (options) => (iow) => (initialState) => (0, widget_1.fromJSX)((setState) => (react_2.default.createElement(exports.Stateful, { initialState: initialState, onStateChange: setState, iow: iow, key: options === null || options === void 0 ? void 0 : options.key })));
exports.stateful = stateful;
const Stateful = (props) => {
    const [state, setState] = (0, react_1.useState)(props.initialState);
    (0, react_1.useEffect)(() => {
        props.onStateChange(state);
    }, [state]);
    return props.iow(state).run(setState);
};
exports.Stateful = Stateful;
